import { Box, Card, Typography } from "@mui/material";
import { Link } from "react-router-dom";
type BillCardProps = {
  name: string;
  url: string;
  categoryName: string;
  logoUrl?: string;
};
export const BillCard = ({ name, url, categoryName, logoUrl }: BillCardProps) => {
  return (
    <Link to={url} style={{ color: "inherit", textDecoration: "none" }}>
      <Card
        sx={{
          height: "15rem",
          display: "grid",
          overflow: "hidden",
          gridTemplateRows: "1fr 1fr",
          cursor: "pointer",
          borderWidth: 1,
          borderRadius: "2.1875rem",
          "&:hover": {
            border: "0.03125rem solid #3b4556",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            position: "relative",
            alignItems: "center",
            overflow: "hidden",
            objectFit: "fill",
            backgroundColor: "secondary.main",
            color: "secondary.contrastText",
            fontWeight: 700,
            fontSize: "3.25rem",
            textTransform: "uppercase",
          }}
        >
          {name.match(/\b\w/g)?.join("")}
          <Box component={"img"} src={logoUrl} sx={{ width: "100%", height: "100%", position: "absolute", left: 0, top: 0, objectFit: "cover" }} />
        </Box>
        <Box sx={{ overflow: "hidden", p: "1.25rem 0.75rem" }}>
          <Typography sx={{ fontSize: "1.25rem", fontWeight: 700, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>{name}</Typography>
          <Typography sx={{ fontSize: "0.875rem", fontWeight: 400 }}>{categoryName}</Typography>
        </Box>
      </Card>
    </Link>
  );
};
